/* globals dataLayer */
;(function ($, window) {
  'use strict'

  window.eah = window.eah || {}

  eah.gtmTracking = (function () {
    function init () {
      // console.log('eah.gtmTracking.init()');

      $(document).on('submitResponse.gtmTracking', function (e, formData, jqForm, options) {
        // console.log('gtm response submitted', e, formData, jqForm, options);
        if (formData && formData.success && !formData.errors) {
          if (dataLayer && formData.extras && formData.extras.crm_id) {
            dataLayer.push({
              'userId': formData.extras.crm_id,
              'event': 'leadacquired'
            })
          }
        }
        return true
      })

      // $('form .ninja-forms-field.button').on('click', function (e) {
      //  // $(this).closest('.open.form').css('top', 0);
      //  // fire();
      // });
    }

    return {
      initialize: init
    }
  }())

  jQuery(window).on('load', function () {
    // load this module only on the live site
    if ((eah && eah.isProduction) || window.location.host === 'www.eahomes.com') {
      eah.gtmTracking.initialize()
    }
  })
}(jQuery, window))
